import styled from '@emotion/styled/macro';
import {
  Environment,
  getEnvironment,
  UserProfile,
} from '@sunrun/sales-experience-shared';
import { QuickLink } from 'components/molecules/QuickLink';
import { publish } from 'helpers/messaging';
import { getRecheckUrl } from 'helpers/reCheckURL';
import {
  isAffiliateHelper,
  isFieldOrAIRHelper,
  isStreetOrFusionHelper,
} from 'helpers/repTypeHelper';

type QuickLinksProps = {
  isCEA: boolean;
  isChannelPartner: boolean;
  isD2H: boolean;
  isFusion: boolean;
  isSRM: boolean;
  userProfile: UserProfile;
};

const RETAIL_APP_URL: Record<Environment, string> = {
  production: 'https://sunrun.lightning.force.com/c/RetailApp.app',
  staging: 'https://sunrun--uat.sandbox.lightning.force.com/c/RetailApp.app',
  relcert: '',
  development: '',
};

const env = getEnvironment();

const QuickLinks = ({
  isChannelPartner,
  isCEA,
  isD2H,
  isFusion,
  isSRM,
  userProfile,
}: QuickLinksProps) => {
  const isAffiliate = isAffiliateHelper(userProfile);
  const isFieldOrAIR = isFieldOrAIRHelper(userProfile);
  const isStreetOrFusion = isStreetOrFusionHelper(userProfile);
  return (
    <Container isCEA={isCEA}>
      <QuickLink
        text="Create a Lead"
        href="#lead"
        onClick={() => {
          publish.createLead();
        }}
      />
      {!isChannelPartner && (
        <>
          <QuickLink
            text="My Training"
            href="https://sunrun.docebosaas.com/"
            target="_blank"
          />
          <QuickLink
            text="My Apps"
            href="https://sunrun.okta.com/app/UserHome"
            target="_blank"
          />
          <QuickLink
            text="Company News"
            href="http://current.sunrun.com/"
            target="_blank"
          />
        </>
      )}
      {isSRM && (
        <QuickLink
          text="Current"
          href="https://current.sunrun.com/site/7b6848bd-8bfb-5e2e-b56d-41b94260487d/content?type=page&pageCategoryId=5daf3824-a623-53e2-a6e8-06a6ec0120a0"
          target="_blank"
        />
      )}
      {isChannelPartner && (
        <QuickLink
          text="Training"
          href="https://sunrun.docebosaas.com/partner/learn"
          target="_blank"
        />
      )}
      {isCEA && (
        <>
          <QuickLink
            text="Retail App"
            href={RETAIL_APP_URL[env]}
            target="_blank"
          />
          <QuickLink
            text="Performance"
            href="https://datastudio.google.com/reporting/4ce3bed3-0f68-4fab-b7bc-b8aedf687c5e"
            target="_blank"
          />
        </>
      )}
      {(isD2H || isFusion) && (
        <QuickLink
          text="Open Terros"
          onClick={() => {
            publish.openTerros();
          }}
        />
      )}
      {isSRM && (
        <QuickLink
          text="Shop RunX"
          href="https://shoprunx.sunrun.com/"
          target="_blank"
        />
      )}
      {(isFieldOrAIR || isStreetOrFusion || isAffiliate) && (
        <QuickLink
          text="Recheck"
          href={getRecheckUrl(userProfile)}
          target="_blank"
        />
      )}
    </Container>
  );
};

const Container = styled.div<{ isCEA?: boolean }>`
  display: flex;
  flex-direction: ${({ isCEA }) => (isCEA ? 'row' : 'column')};
  flex-wrap: ${({ isCEA }) => (isCEA ? 'wrap' : 'unset')};
  align-items: flex-start;
  padding: 0px;
  gap: 24px;

  max-width: ${({ isCEA }) => (isCEA ? '951px' : 'unset')};

  & > a {
    width: ${({ isCEA }) => (isCEA ? '252px' : 'initial')};
    justify-content: ${({ isCEA }) => (isCEA ? 'center' : 'unset')};
    @media (max-width: 768px) {
      width: unset;
    }
  }
`;

export { QuickLinks };
